const _temp0 = require("../images/icons/alert.svg");
const _temp1 = require("../images/icons/cancer.svg");
const _temp2 = require("../images/icons/diabetes.svg");
const _temp3 = require("../images/icons/heart-disease.svg");
const _temp4 = require("../images/icons/high-blood-pressure.svg");
const _temp5 = require("../images/icons/high-cholesterol.svg");
const _temp6 = require("../images/icons/housing.svg");
const _temp7 = require("../images/icons/income.svg");
const _temp8 = require("../images/icons/median-age.svg");
const _temp9 = require("../images/icons/obesity.svg");
const _temp10 = require("../images/icons/over-65.svg");
const _temp11 = require("../images/icons/population.svg");
const _temp12 = require("../images/icons/white-alert.svg");
module.exports = {
  "alert": _temp0,
  "cancer": _temp1,
  "diabetes": _temp2,
  "heart-disease": _temp3,
  "high-blood-pressure": _temp4,
  "high-cholesterol": _temp5,
  "housing": _temp6,
  "income": _temp7,
  "median-age": _temp8,
  "obesity": _temp9,
  "over-65": _temp10,
  "population": _temp11,
  "white-alert": _temp12
}